/**
 * Created by frank.law on 11/14/17.
 */
import React from 'react';
import '../../css/login.css';
import Logo from './Logo';
import FormFieldContainer from './formFields/FormFieldContainer';
import BackToLoginLink from "./BackToLoginLink";
import BypassSSORedirect from "./BypassSSORedirect";
import OdpLoginRoute from "./OdpLoginRoute";


import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {responseError, submitInitChallenge, submitInitResetChallenge, submitInitStandardLoginChallenge, submitInitStandardLoginRequest, submitInitStandardLoginSent} from '../actions/actions';
import stringifyQuery from 'query-string-for-all'
import {BASE_PATH} from '../utils/APIUtility';

class LoginContainer extends React.Component {

    componentDidMount() {
        const {requestUsernameForm, requestResetPasswordForm, requestStandardLoginRedirect, requestStandardLoginForm,
            requestStandardLoginSent, resetPassword, standardLoginRequest, standardLoginRedirect, responseTypeFromState, clientIdFromState,
            redirectURIFromState, stateFromState, redirectFromState , codeChallengeFromState, codeChallengeMethodFromState,
            promptFromState, displayError, displayErrorForm} = this.props;

        const locationURL = this.props.location;
        const stringQuery = (locationURL) ? stringifyQuery.parse(locationURL.search) : {};
        let username = window.__user;
        if(!Boolean(username)) {
            username = null;
        }

        if (standardLoginRequest) {
            if (stringQuery.loginLinkSent) {
                requestStandardLoginSent();
            } else {
                requestStandardLoginForm();
            }
        } else if (standardLoginRedirect) {
            // Handle standard login redirect and validate the token exists
            let magicToken = stringQuery.magic_token;
            if (magicToken && magicToken.length > 0) {
                requestStandardLoginRedirect(magicToken);
            }
        } else if (resetPassword) {
            // Pull out the query params from the location(URL)

            let resetToken = stringQuery.magic_token;

            if (resetToken && resetToken.length > 0) {
                requestResetPasswordForm(resetToken);
            }
        } else if (displayError) {
            let errorTitle = window.__errorTitle;
            if(!Boolean(errorTitle)) {
                errorTitle = "Error";
            }
            let errorMessage = window.__errorMessage;
            if(!Boolean(errorMessage)) {
                errorMessage = "An error occurred.";
            }
            let errorIcon = window.__errorIcon;
            if(!Boolean(errorIcon)) {
                errorIcon = "band-aids";
            }
            const error = {
                body: {
                    title: errorTitle,
                    error: errorMessage,
                    iconName: errorIcon
                }
            };
            displayErrorForm(error);
        } else {
          let responseType, clientId, redirectURI, state, redirect, tenantAlias, tenantName, tenantURL,
              codeChallenge, codeChallengeMethod, prompt;
          if (stringQuery) {
            responseType = stringQuery.response_type;
            clientId = stringQuery.client_id;
            redirectURI = stringQuery.redirect_uri;
            state = stringQuery.state;
            redirect = stringQuery.redirect;
            tenantAlias = stringQuery.tenantAlias;
            tenantName = stringQuery.tenantName;
            tenantURL = stringQuery.tenantURL;
            codeChallenge = stringQuery.code_challenge;
            codeChallengeMethod = stringQuery.code_challenge_method;
            prompt = stringQuery.prompt;
          }
          else {
            responseType = responseTypeFromState;
            clientId = clientIdFromState;
            redirectURI = redirectURIFromState;
            state = stateFromState;
            redirect = redirectFromState;
            codeChallenge = codeChallengeFromState;
            codeChallengeMethod = codeChallengeMethodFromState;
            prompt = promptFromState;
          }

          // Default
          requestUsernameForm(responseType, clientId, redirectURI, state, redirect, tenantAlias, tenantName, tenantURL, codeChallenge, codeChallengeMethod, prompt, username);
        }
    }


    render() {
        const loginHelpEndpoint = process.env.REACT_APP_LOGIN_HELP_ENDPOINT;
        const {challenge, clientIdFromState, responseTypeFromState, redirectFromState, odpLoginRoute } = this.props;

        let backToLoginLink = [];
        if (challenge && clientIdFromState && responseTypeFromState && challenge.nextChallenge !== 'user') {
            if (challenge.nextChallenge === 'tenant' && redirectFromState !== 'n') {
                backToLoginLink = (<BypassSSORedirect/>);
            } else if (challenge.nextChallenge === 'tenant' && redirectFromState === 'n') {
                challenge.prompts.inputPrompt.label = challenge.prompts.inputPrompt.label.concat(" (Bypassing SSO Redirect)");
                backToLoginLink = (<BackToLoginLink/>);
            } else {
                backToLoginLink = (<BackToLoginLink/>);
            }
        }
        return (
            <div className="login">
                <div className="login-container" role="main">
                    <Logo />

                    <FormFieldContainer />
                    {challenge && challenge.nextChallenge === 'user' && odpLoginRoute &&
                        <OdpLoginRoute odpLoginRoute={odpLoginRoute} />
                    }
                    <div className="footer-links">
                        {backToLoginLink}
                        <a className="need-help" href={BASE_PATH + loginHelpEndpoint} target="_blank" rel="noopener noreferrer">Need Help?</a>
                    </div>
                </div>
            </div>
        );
    }
}

LoginContainer.propTypes = {
    resetPassword: PropTypes.bool,
    standardLoginRequest: PropTypes.bool,
    standardLoginRedirect: PropTypes.bool,
    location: PropTypes.object,
    displayError: PropTypes.bool
};

const mapStateToProps = (state) => {
    return {
        username: state.login.username,
        challenge: state.login.challengeResponse,
        responseTypeFromState: state.login.responseType,
        clientIdFromState: state.login.clientId,
        redirectURIFromState: state.login.redirectURI,
        stateFromState: state.login.state,
        redirectFromState: state.login.redirect,
        codeChallengeFromState: state.login.codeChallenge,
        codeChallengeMethodFromState: state.login.codeChallengeMethod,
        promptFromState: state.login.prompt,
        odpLoginRoute: state.login.challengeResponse && state.login.challengeResponse.prompts && state.login.challengeResponse.prompts.odpLoginRoute
            ? state.login.challengeResponse.prompts.odpLoginRoute.value
            : null
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestUsernameForm: (responseType, clientId, redirectURI, state, redirect, tenantAlias, tenantName, tenantURL, codeChallenge, codeChallengeMethod, prompt, username) => {
            dispatch(submitInitChallenge(responseType, clientId, redirectURI, state, redirect, tenantAlias, tenantName, tenantURL,
                codeChallenge, codeChallengeMethod, prompt, username));
        },
        requestResetPasswordForm: (resetToken) => {
            dispatch(submitInitResetChallenge(resetToken));
        },
        requestStandardLoginRedirect: (magicToken) => {
            dispatch(submitInitStandardLoginChallenge(magicToken));
        },
        requestStandardLoginForm: () => {
            dispatch(submitInitStandardLoginRequest());
        },
        requestStandardLoginSent: () => {
            dispatch(submitInitStandardLoginSent());
        },
        displayErrorForm: (error) => {
            dispatch(responseError(error));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
